import React, {Component} from 'react';
import { Select } from 'antd';
const { Option } = Select;

/**
 * creat by tianruojun
 * 选部门组件（树形）
 * @description 一个用来选部门的弹窗组件，可以设置回显和返回选择的部门
 * @class TreeModuleBySelectDept
 * @extends {Component}
 */
export default class Select_rmt extends Component {
    componentWillMount() {
        if(this.props.defaultValue != undefined) {
            this.props.onChange(this.props.defaultValue);
        }
    }

    render() {

        let {placeholder,onChange,value,selectValues,defaultValue, style = {}} = this.props;
        return (
            <div className={"selectComponent"}>
                <Select getPopupContainer={triggerNode => triggerNode.parentElement} placeholder={placeholder} defaultValue={defaultValue} value={value} allowClear style={{ width: 120, ...style }} 
                    showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(val)=>{onChange(val)}
                 }
                >
                    {
                        selectValues.map((item,index)=>{
                            return <Option title={item.name} key={index} value={item.key}>{item.name}</Option>
                        })
                    }
                </Select>
                <style>{`
                    .selectComponent .ant-select-selection{border: 1px solid #eef2fb !important; background-color: #f5f8fc !important;}
                `}</style>
            </div>
        )
    }

}